<template>
  <div class="main" v-if="pages != null">

    <slider ref="slider"
            :pages="pages"
            :sliderinit="sliderinit"
            @slide="onSlide"
            @init="onInit"
    >
      <!-- slot  -->
    </slider>

    <!--<router-link to="/">Sunny Factory</router-link>-->
    <left-side>
    </left-side>
    <slider-controller
      ref="slider-controller"
      :sliderInterval="this.interval"
      @autoPlayToggle="autoPlayToggle"
    />
    <notice/>
    <!--<button @click="slide">asdfasdf</button>-->
  </div>
</template>

<script>
  import {mapState , mapActions} from 'vuex'
  import slider from 'vue-concise-slider'
  import LeftSide from '@/components/leftSide'
  import SliderController from '@/components/SliderController'
  import Notice from '@/components/Notice'

  export default {
    name: 'Main',
    components: {
      slider,
      'left-side': LeftSide,
      'SliderController': SliderController,
      Notice
    },
    computed : {
      ...mapState('mainStore' , ['pages']) ,
      /*pages () {
        /!*{
          html: `<div class="slideCommentWrap" style="position: absolute; right:10%; bottom:20%;">
                  <h3 style="text-align: right;">창의적인 UI, 그리고 컨텐츠</h3>
                  <p style="text-align: right; font-size:1.6rem; font-weight:100;">
                  언제 어디서나, 모든 기기에 똑같은 화면과 기능이 구현되는<br/>
                   써니 팩토리만의 다양한 컨텐츠로 다가갑니다.</p></div>`,
            style: {
          background: 'url(https://d77k7si2heyyr.cloudfront.net/images/main/sf-main-bg-2.jpg)'
        }
        }*!/

        return this.mains.map( n => {
          return ({
            html : `<div class="slideCommentWrap" style="position: absolute; right:10%; bottom:20%;">
                  <h3 style="text-align: right;">${n.summary}</h3>
                  <p style="text-align: right; font-size:1.6rem; font-weight:100;">
                  ${n.explanation}</p></div>` ,
            style: {
              background: `url(https://d77k7si2heyyr.cloudfront.net/upload_files/main/${n.savedFileName})`
            }
          })
        });
      },*/
    },
    beforeCreate() {

    },
    created() {
      this.API__GET__MAINS()
        .then( res => {
          if(res) {
            this.$nextTick(function () {
              //document.getElementsByClassName('slider-pagination-bullets')[0].style.display = 'none';
              this.swipeEventRemover();
            });
          }
        })
      //this.setPages();
    },
    mounted() {
      /*if(document.getElementsByClassName('slider-pagination-bullets')){
        const bullets = [].slice.call(document.getElementsByClassName('slider-pagination-bullets'));
        //document.getElementsByClassName('slider-pagination-bullets')[0].style.display = 'none';
        //console.dir(document.getElementsByClassName('slider-pagination-bullets'));
        console.log(bullets);
      }*/
      //this.swipeEventRemover();
      /*this.$watch('track' , function () {
      })*/

    },
    data() {
      return {
        //Image list[arr]
        //Web Hook Slack Test
        //pages : null ,
        interval: 3000,
        // Sliding configuration[obj]
        sliderinit: {
          currentPage: 0,
          thresholdDistance: 100,
          thresholdTime: 3000,
          autoplay: 3000,
          loop: true,
          infinite: 1,
          slidesToScroll: 1
        }
      }
    },
    methods: {
      ...mapActions('mainStore' , ['API__GET__MAINS']) ,
      swipeEventRemover () {
        this.$refs.slider.swipeStart = function () {return};
        this.$refs.slider.swipeMove = function () {return};
        this.$refs.slider.swipeEnd = function () {return};

      },
      onSlide (data)  {

      },
      onInit (data) {
        //console.log(data);
      },
      autoPlayToggle (play) {
        //console.log(this.$refs.slider);
        if(play){
          this.$refs.slider.$emit('autoplayStart' , this.interval);
        }
        else{
            this.$refs.slider.$emit('autoplayStop');
        }
        //console.log('dfdf');
      },
      autoPlayStart () {

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/styles/Global.scss";
  .main {
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: relative;
    .slider-pagination-bullets {
      display: none !important;
    }
    .slideCommentWrap {
      position: absolute;
      right:10%;
      bottom:20%;
        @include respond-to('medium') {
          position: initial;
        }
      >h3{
        text-align: right;
        @include respond-to('medium') {
          font-size:2rem;
          text-align: center;
          white-space: pre-wrap;
        }
        @include respond-to('small') {
          font-size:1.6rem;
          text-align: center;
          white-space: pre-wrap;
        }
      }
      >p{
        text-align: right;
        font-size:1.6rem;
        font-weight:100;
        white-space: pre-wrap;
        @include respond-to('medium') {
          font-size:1.2rem;
        }
        @include respond-to('small') {
          font-size:1rem;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main.vue